import {
  getDisplayNameFromLineitem,
  GetTicketTypeNameParams,
} from "~components/checkout/order";
import { LineItem, LineItemType } from "~graphql/sdk";
import {
  formatSeatLocation,
  FormatSeatLocationParams,
} from "~lib/helpers/formatSeatLocation";
import { PickTypes } from "~lib/helpers/types";

export interface GetOrderSummaryLineItemSubtitleParams
  extends FormatSeatLocationParams,
    PickTypes<
      LineItem,
      {
        type: true;
        quantity: true;
        pointItem: {
          amount: true;
        };
      }
    > {}

export function getOrderSummaryLineItemSubtitle(
  lineItem: GetOrderSummaryLineItemSubtitleParams,
  pointName: string | undefined
) {
  if (lineItem.type === LineItemType.Point) {
    const amount = lineItem.pointItem?.amount;

    if (amount == null || pointName == null) {
      // Missing data for point items; avoid returning "NaN undefined"
      return "";
    }

    return `${lineItem.quantity * amount} ${pointName}`;
  }

  return formatSeatLocation(
    lineItem.seatZone,
    lineItem.seatSection,
    lineItem.seatLabel
  );
}

export interface GetOrderSummaryLineItemTitleParams
  extends GetTicketTypeNameParams {
  quantity: LineItem["quantity"];
}

export function getOrderSummaryLineItemTitle(
  lineItem: GetOrderSummaryLineItemTitleParams
) {
  const name = getDisplayNameFromLineitem(lineItem);
  return `${lineItem.quantity} x ${name}`;
}
